<template>
    <div v-if="attachments && attachments.length" class="attachments-block mt-4">
        <div class="d-flex align-center mb-2">
            <span class="font-weight-bold title">Attachments</span>
            <span class="attachment-count">
        {{ attachments.length }}
      </span>
        </div>

        <div class="attachments-list">
            <div
                v-for="file in attachments"
                :key="file.id"
                class="attachment-card"
            >
                <a :href="file.url" target="_blank" rel="noopener noreferrer">
                    <div v-if="isImage(file?.mime_type)" class="attachment-preview">
                        <img :src="file.url" alt="" />
                    </div>
                    <div v-else class="attachment-preview icon-preview">
                        <i :class="['fa', getFileIcon(file?.mime_type)]"></i>
                    </div>
                </a>
                <div class="attachment-meta">
                    <a :href="file.url" target="_blank" class="file-name">
                        {{ getFileName(file.name) }}
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AttachmentsBlock',
    props: {
        attachments: {
            type: Array,
            required: true
        }
    },
    methods: {
        isImage(mime) {
            return mime?.startsWith('image/');
        },
        getFileName(name) {
            return name?.length > 20 ? name.slice(0, 20) + '…' : name;
        },
        getFileIcon(mime) {
            if (!mime) return 'fa-file';
            if (mime.includes('pdf')) return 'fa-file-pdf';
            if (mime.includes('word')) return 'fa-file-word';
            if (mime.includes('excel') || mime.includes('spreadsheet')) return 'fa-file-excel';
            if (mime.includes('zip')) return 'fa-file-archive';
            return 'fa-file';
        }
    }
}
</script>

<style scoped>
.title {
    font-size: 16px !important;
    font-weight: 600 !important;
    color: #1f2b46;
}

.attachment-count {
    margin-left: 6px;
    padding: 0 7px;
    font-size: 11px;
    border-radius: 10px;
    background-color: #dfe1e6;
    block-size: min-content;
    display: inline-flex;
}

.attachments-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    margin-top: 8px;
}

.attachment-card {
    width: 100px;
    margin: 6px;
    text-align: center;
    font-size: 13px;
}

.attachment-preview {
    height: 64px;
    width: 90px;
    margin: 0 auto 4px;
    background: #fff;
    border-radius: 6px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.05);
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}

.attachment-preview img {
    max-height: 100%;
    max-width: 100%;
    object-fit: contain;
}

.icon-preview i {
    font-size: 28px;
    color: #888;
}

.file-name {
    display: block;
    color: #1976d2;
    text-decoration: none;
    margin-bottom: 2px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 13px;
}
</style>
